export const CARGO_ITEMS = Object.freeze({
  boots: Object.freeze({ weight: 2, water: 1, push: 0, view: 0 }),
  gloves: Object.freeze({ weight: 1, water: 0, push: 1, view: 0 }),
  scope: Object.freeze({ weight: 2, water: 0, push: 0, view: 2 }),
  exosuit: Object.freeze({ weight: 4, water: 1, push: 1, view: 1 }),
});
export const CARGO_BOARD = Object.freeze(['#######', '...~...', '...~...', '...~...', '#######']);
export const CARGO_DIRECTIONS = Object.freeze({ up: [0, -1], right: [1, 0], down: [0, 1], left: [-1, 0] });
export const CARGO_CAPACITY = 3;
const clone = value => JSON.parse(JSON.stringify(value));
const same = (a, b) => a.x === b.x && a.y === b.y;
const ok = () => ({ ok: true, reason: 'ok' });
const no = reason => ({ ok: false, reason });
export const cargoWeight = items => items.reduce((total, item) => total + CARGO_ITEMS[item].weight, 0);

export class PlayerInterfaceModel {
  constructor() { this.reset(); }
  get state() { return clone(this._state); }
  reset() {
    this._state = { player: { x: 0, y: 2 }, crate: { x: 2, y: 2 }, goal: { x: 5, y: 2 }, exit: { x: 6, y: 2 }, equipped: [], draft: null, turn: 0, outcome: 'playing', history: [] };
    this._undo = [];
    return this.state;
  }
  openEquipment() {
    if (this._state.draft) return no('menu');
    this._state.draft = [...this._state.equipped]; return ok();
  }
  itemAvailability(item) {
    const draft = this._state.draft;
    if (!draft) return no('no-menu');
    if (!Object.hasOwn(CARGO_ITEMS, item)) return no('unknown');
    return !draft.includes(item) && cargoWeight([...draft, item]) > CARGO_CAPACITY ? no('capacity') : ok();
  }
  toggleDraft(item) {
    const availability = this.itemAvailability(item); if (!availability.ok) return availability;
    const draft = this._state.draft;
    this._state.draft = draft.includes(item) ? draft.filter(entry => entry !== item) : [...draft, item]; return ok();
  }
  cancelEquipment() { if (!this._state.draft) return no('no-menu'); this._state.draft = null; return ok(); }
  confirmEquipment() {
    const draft = this._state.draft; if (!draft) return no('no-menu');
    this._state.draft = null;
    if (JSON.stringify(draft) !== JSON.stringify(this._state.equipped)) { this._remember('equip'); this._state.equipped = [...draft]; }
    return ok();
  }
  _remember(action) {
    this._undo.push(clone(this._state));
    if (this._undo.length > 200) this._undo.shift();
    this._state.history.push({ action, turn: this._state.turn + (action === 'equip' ? 0 : 1) });
    if (this._state.history.length > 200) this._state.history.shift();
  }
  _plan(direction) {
    const s = this._state;
    if (s.draft) return no('menu');
    if (s.outcome === 'won') return no('complete');
    if (!Object.hasOwn(CARGO_DIRECTIONS, direction)) return no('direction');
    const [dx, dy] = CARGO_DIRECTIONS[direction], next = { x: s.player.x + dx, y: s.player.y + dy };
    const tile = CARGO_BOARD[next.y]?.[next.x];
    if (!tile || tile === '#') return no('wall');
    if (tile === '~' && !s.equipped.some(item => CARGO_ITEMS[item].water)) return no('boots');
    let crate = s.crate;
    if (same(next, crate)) {
      if (!s.equipped.some(item => CARGO_ITEMS[item].push)) return no('gloves');
      crate = { x: crate.x + dx, y: crate.y + dy };
      const beyond = CARGO_BOARD[crate.y]?.[crate.x];
      if (!beyond || beyond === '#' || same(crate, s.exit)) return no('cargo-wall');
    }
    if (same(next, s.exit) && !same(crate, s.goal)) return no('locked');
    return { ...ok(), next, crate, action: same(next, s.crate) ? 'push' : 'move' };
  }
  legalMoves() { return Object.fromEntries(Object.keys(CARGO_DIRECTIONS).map(direction => { const result = this._plan(direction); return [direction, { ok: result.ok, reason: result.reason }]; })); }
  move(direction) {
    const plan = this._plan(direction); if (!plan.ok) return plan;
    this._remember(plan.action); const s = this._state;
    s.player = plan.next; s.crate = { ...plan.crate }; s.turn++;
    if (same(s.player, s.exit)) s.outcome = 'won';
    return ok();
  }
  undo() {
    if (this._state.draft) return no('menu');
    if (!this._undo.length) return no('history');
    this._state = this._undo.pop(); return ok();
  }
}
